import React from 'react';
import { AuthConsumer } from 'contexts/auth'

const withAuthentication = (Component) => {
  return class extends React.Component {
    render() {
      return(
        <AuthConsumer>
          {( isAuthenticated, userHasAuthenticated, jwtToken, isAuthenticating ) => 
            <Component {...isAuthenticated} {...this.props} />
          }
        </AuthConsumer>
      )
    }
  }
}

export default withAuthentication;